

















































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import { EducationProtocolEdit as IEducationProtocolEdit } from "@/api/models/education-protocol-edit";
import { Course as ICourse } from "@/api/models/course";
import ListenerTableItem from "@/components/education/ListenerTableItem.vue";
import DocTemplateGenerate from "@/components/doc-tempates/DocTemplateGenerate.vue";
import api from "@/getinfo-api";
import ListenerTable from "@/components/tables/ListenerTable.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import DocumentArchiveButton from "@/components/form/DocumentArchiveButton.vue";
import { generatePdf } from "@/utils/files-helper";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";

@Component({
  components: {
    DocTemplateGenerateV2,
    DocumentArchiveButton,
    EntityFiles,
    CustomButton,
    TextField,
    CBlock,
    CBreadCrumbs,
    ListenerTable,
    ListenerTableItem,
    DocTemplateGenerate
  }
})
export default class EducationProtocol extends Vue {
  currentProtocol!: IEducationProtocol;
  course!: ICourse;
  isLoadingFiles: boolean = false;
  isSingleFile: boolean = false;

  data() {
    return {
      currentProtocol: undefined,
      course: undefined,
      laborWorker: undefined
    };
  }

  generateFileName() {
    const timestamp = new Date();
    const formattedDate = this.moment(timestamp).format("LLL");
    return `Итоговые документы по протоколу ${this.currentProtocol.number} от ${formattedDate}`;
  }

  async _generatePdf(file: any) {
    this.isLoadingFiles = true;
    const response = await generatePdf(file)
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
    this.addFiles([response.id], true);
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    let params: IEducationProtocolEdit = {
      fileIds:
        this.currentProtocol.files && fromDocTemplate
          ? [...this.currentProtocol.files.map((el: any) => el.id), ...files]
          : [...files],
      listeners: this.currentProtocol.listeners
        ? this.currentProtocol.listeners.map((el: any) => el.id)
        : [],
      number: this.currentProtocol.number,
      ownerId: this.currentProtocol.owner.id,
      courseId: this.currentProtocol.course.id,
      commission: this.currentProtocol.commission,
      reason: this.currentProtocol.reason,
      protocolCreatedAt: this.currentProtocol.protocolCreatedAt,
      signedAt: this.currentProtocol.signedAt
    };

    this.isLoadingFiles = true;

    api.EducationProtocolApi.edit(this.currentProtocol.id, params)
      .then((res: { data: IEducationProtocol }) => {
        this.currentProtocol = res.data;
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
  }

  get status() {
    return !!this.currentProtocol?.signedAt;
  }

  findListener(listenerId: string, number: string) {
    const listener = this.allListeners?.find((el: any) => el.id === listenerId);
    const name = listener?.studentFullName ?? listener?.user?.fullName ?? "";

    return `${number}-${name}`;
  }

  get finalDocumentsData() {
    return this.$store.getters["finalDocuments/GET_LIST"].map((el: any) => {
      return {
        id: el.id,
        number: this.findListener(el?.listenerId, el.number)
      };
    });
  }

  get finalDocumentIdsForGenerated() {
    const uniq = new Set(
      this.finalDocumentsData?.map(
        (el: { id: string; number: string }) => el.id
      )
    );
    return [...uniq];
  }

  get allListeners() {
    return this.$store.getters["finalDocuments/GET_LIST"]?.[0]?.protocol
      ?.listeners;
  }

  get courseLink() {
    const v1 = {
      name: "courseView",
      params: { courseId: this.currentProtocol?.course?.id }
    };
    const v2 = {
      name: "course",
      params: { id: this.currentProtocol?.course?.id }
    };

    return this.currentProtocol?.course?.version === "v1" ? v1 : v2;
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "educationProtocolList" },
        label: `${this.$tc(this.$translate.TrainingProtocol)}`
      },
      {
        label: this.currentProtocol.number
      }
    ];
  }

  @Watch("selectedCompany")
  updateCompany() {
    this.getProtocolById();
  }

  getProtocolById() {
    api.EducationProtocolApi.get(this.$route.params.id).then(
      async (res: { data: IEducationProtocol }) => {
        this.currentProtocol = res.data;
      }
    );
  }

  created() {
    if (this.selectedCompany) {
      this.getProtocolById();
    }
  }
}
